// src/components/TradeTable.tsx
import React, { useState } from "react";
import {
  Box, Button, Typography,
  TableContainer, Paper, Table, TableHead,
  TableRow, TableCell, TableBody, TableSortLabel
} from "@mui/material";
import { Trade } from "./TradeVisualizer";

interface Props { trades: Trade[]; onReset: () => void; }

export default function TradeTable({ trades, onReset }: Props) {
  const [dir, setDir] = useState<'asc'|'desc'>('asc');
  const sorted = [...trades].sort((a,b) => dir==='asc' ? a.filltime.localeCompare(b.filltime) : b.filltime.localeCompare(a.filltime));
  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="h6">Trade Details</Typography>
        <Button variant="outlined" onClick={onReset}>Back to Summary</Button>
      </Box>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>
                <TableSortLabel active direction={dir} onClick={() => setDir(d => d==='asc'?'desc':'asc')}>Time</TableSortLabel>
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}>Size</TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}>Price</TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}>Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sorted.map(t => (
              <TableRow key={t.orderid}>
                <TableCell>{t.filltime}</TableCell>
                <TableCell>{t.transactiontype}</TableCell>
                <TableCell align="right">{t.fillsize}</TableCell>
                <TableCell align="right">{t.fillprice.toFixed(2)}</TableCell>
                <TableCell align="right">{t.tradevalue.toFixed(2)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}